import { isIosDevice } from './geolocation-platform';

type DeviceOrientationEventWithPermission = typeof DeviceOrientationEvent & {
  requestPermission?: () => Promise<'granted' | 'denied' | 'default'>;
};

export function isDeviceOrientationSupported(): boolean {
  return typeof window !== 'undefined' && 'DeviceOrientationEvent' in window;
}

export function deviceOrientationPermissionRequired(): boolean {
  if (!isDeviceOrientationSupported()) {
    return false;
  }

  const ctor = DeviceOrientationEvent as DeviceOrientationEventWithPermission;
  return typeof ctor.requestPermission === 'function';
}

export function shouldPromptForDeviceOrientation(): boolean {
  return isIosDevice() && deviceOrientationPermissionRequired();
}

export function deviceOrientationIdleHint(): string {
  return 'Appuyez sur le bouton ci-dessous pour autoriser la boussole.';
}

export function deviceOrientationPermissionDeniedMessage(): string {
  if (isIosDevice()) {
    return (
      'Accès refusé. Autorisez les capteurs de mouvement via le bouton ci-dessus, ' +
      'ou dans Réglages → Confidentialité → Capteurs de mouvement et orientation → Safari.'
    );
  }

  return 'Accès à la boussole refusé. Réessayez ou continuez sans le cap.';
}
